import script from "./SectionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionCard.vue?vue&type=script&setup=true&lang=js"

import "./SectionCard.vue?vue&type=style&index=0&id=3fc86d13&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc86d13"]])

export default __exports__